import React from 'react';
import {
  Box,
  Typography,
  CircularProgress,
  Grid,
  Alert,
  Paper
} from '@mui/material';
import {
  EventAvailable as EventAvailableIcon
} from '@mui/icons-material';
import AppointmentCard from '../AppointmentCard/AppointmentCard';
import PropTypes from 'prop-types';

function AppointmentList({ 
  appointments = [], 
  loading = false, 
  error = null,
  onConfirm,
  onComplete,
  onStartVideoCall,
  onViewDetails,
  emptyMessage = "No appointments found",
  emptySubMessage = "Appointments will appear here when available"
}) {
  if (loading) {
    return (
      <Box 
        sx={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          minHeight: '300px',
          flexDirection: 'column'
        }}
      >
        <CircularProgress size={40} />
        <Typography variant="body1" sx={{ mt: 2 }}>
          Loading appointments...
        </Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Alert severity="error" sx={{ mb: 2 }}>
        <Typography variant="body1">
          <strong>Error loading appointments:</strong> {error}
        </Typography>
      </Alert>
    );
  }

  if (!appointments || appointments.length === 0) {
    return (
      <Paper 
        elevation={1} 
        sx={{ 
          p: 6, 
          textAlign: 'center',
          backgroundColor: 'grey.50',
          border: '2px dashed',
          borderColor: 'grey.300'
        }}
      >
        <EventAvailableIcon 
          sx={{ 
            fontSize: 64, 
            color: 'grey.400',
            mb: 2
          }} 
        />
        <Typography variant="h6" gutterBottom color="text.secondary">
          {emptyMessage}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {emptySubMessage}
        </Typography>
      </Paper>
    );
  }

  return (
    <Box>
      <Grid container spacing={2}>
        {appointments.map((appointment) => (
          <Grid item xs={12} key={`${appointment.userId}-${appointment.requestId}`}>
            <AppointmentCard
              appointment={appointment}
              onConfirm={onConfirm}
              onComplete={onComplete}
              onStartVideoCall={onStartVideoCall}
              onViewDetails={onViewDetails}
              isConfirmed={appointment.status?.toUpperCase() === 'CONFIRMED'}
              isCompleted={appointment.status?.toUpperCase() === 'COMPLETED'}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

AppointmentList.propTypes = {
  appointments: PropTypes.arrayOf(
    PropTypes.shape({
      requestId: PropTypes.string.isRequired,
      userId: PropTypes.string.isRequired,
      status: PropTypes.string.isRequired
    })
  ),
  loading: PropTypes.bool,
  error: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  onComplete: PropTypes.func.isRequired,
  onStartVideoCall: PropTypes.func.isRequired,
  onViewDetails: PropTypes.func.isRequired,
  emptyMessage: PropTypes.string,
  emptySubMessage: PropTypes.string
};

export default AppointmentList; 